import { Alert, Box, Fade, Grid } from "@mui/material";
import { Paper, Typography, TextField, Rating, Button } from "@mui/material";
import { CardContent } from "@material-ui/core";
import { useEffect, useState } from "react";
import { getReviews, postReview, useApi } from "../api/Api";
import LoginForm from "../components/LoginForm";
import { useTranslation } from "react-i18next";

const ReviewPage = () => {
  const { t } = useTranslation();
  const api = useApi();

  const [rating, setRating] = useState("");
  const [name, setName] = useState("");
  const [comment, setComment] = useState("");
  const [avgReview, setAvgReview] = useState(-1);

  const [alertMsg, setAlertMsg] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");

  const onSubmit = (e) => {
    e.preventDefault();
    onReview({
      rating: rating,
      name: name,
      comment: rating > 3 ? "" : comment,
    });
  };

  const fetchReviews = () => {
    getReviews(api)
      .then((response) => {
        setAvgReview(response.data);
      })
      .catch((error) => {
        console.log(error.response);
      });
  };

  useEffect(() => {
    fetchReviews();
  }, []);

  const onReview = (review) => {
    postReview(api, review)
      .then((response) => {
        console.log(response.data);
        setAlertMsg(response.data["msg"]);
        setAlertSeverity("success");
        fetchReviews();
      })
      .catch((error) => {
        console.log(error);
        setAlertMsg(error.response["data"]);
        setAlertSeverity("error");
      });
  };

  return (
    <Box>
      <Grid container justifyContent="center">
        <Paper elevation={10} sx={{ mx: 2, mt: 2, p: 2, maxWidth: 500 }}>
          <Grid item xs={12} align="center">
            <Typography>{t("avg_review_score")}</Typography>
            <Rating precision={0.5} value={avgReview} disabled={true} />
          </Grid>
        </Paper>
      </Grid>
      {window.localStorage.getItem("token") === null ? (
        <Grid container justifyContent="center">
          <Alert
            severity="warning"
            variant="filled"
            sx={{ mt: 2, maxWidth: 500 }}
          >
            {t("login_review_prompt")}
          </Alert>
          <LoginForm />
        </Grid>
      ) : (
        <Grid container justifyContent="center">
          <Paper elevation={10} sx={{ m: 2, maxWidth: 500 }}>
            <CardContent>
              <form onSubmit={onSubmit}>
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  spacing={2}
                >
                  <Grid item container xs={12} justifyContent="center">
                    <Typography component="legend">
                      {t("your_rating")}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} align="center">
                    <Rating
                      id="rating"
                      precision={0.5}
                      onChange={(e) => setRating(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="left" variant="h8">
                      {t("name_optional")}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      id="textfield-name"
                      fullWidth
                      label={t("enter_your_name")}
                      variant="outlined"
                      onChange={(e) => setName(e.target.value)}
                    />
                  </Grid>
                  {rating > 3 || !rating ? (
                    <></>
                  ) : (
                    <>
                      <Grid item xs={12}>
                        <Typography align="left" variant="h8">
                          {t("comment_optional")}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          id="textfield-comment"
                          fullWidth
                          label={t("enter_comment")}
                          multiline
                          rows={4}
                          onChange={(e) => setComment(e.target.value)}
                        />
                      </Grid>
                    </>
                  )}
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      fullWidth
                      color="secondary"
                      type="submit"
                    >
                      {t("submit_review")}
                    </Button>
                  </Grid>
                  {alertMsg ? (
                    <Fade in={true}>
                      <Grid item xs={12}>
                        <Alert severity={alertSeverity}>{alertMsg}</Alert>
                      </Grid>
                    </Fade>
                  ) : (
                    <></>
                  )}
                </Grid>
              </form>
            </CardContent>
          </Paper>
        </Grid>
      )}
    </Box>
  );
};

export default ReviewPage;
